import React from "react";
import autobind from "class-autobind";
import shortid from "shortid";
import { FormGroup } from "../../form/group/index";
import {Input, InputNumber} from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaPlusCircle, FaMinusCircle, FaCopy } from "react-icons/fa";
import { Checkbox } from "../../form/checkbox/index";
import {Tooltip} from "../../tooltip/index";

interface Props {
  taxes: BusinessTaxes;
  onChange: (h: BusinessTaxes) => void;
}

export class FieldTaxes extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
    autobind(this);
  }

  add() {
    const taxes = [ ...this.props.taxes ];
    taxes.push({
      _id: shortid.generate(),
      name: "",
      // @ts-ignore
      rate: "",
      compound: false,
    });
    this.props.onChange(taxes);
  }

  copy(i: number) {
    const taxes = [ ...this.props.taxes ];
    const tax = { ...taxes[i] };
    taxes.push(tax);
    this.props.onChange(taxes);
  }

  remove(i: number) {
    const taxes = ([ ...this.props.taxes ]);
    taxes.splice(i, 1);
    this.props.onChange(taxes);
  }

  change(i: number, key: keyof BusinessTaxDetail, value: string | number | boolean) {
    const taxes = [ ...this.props.taxes ];
    taxes[i][key] = value;
    this.props.onChange(taxes);
  }

  render() {
    return (
      <div>

        { this.props.taxes.length === 0 &&
          <Button size="xs" color="primary-inverse" type="button" onClick={this.add}>
            Create New Tax
          </Button>
        }

        { this.props.taxes.map((item, i) => {
          return (
            <div key={i} className="flex-line" style={{ alignItems: "flex-end" }}>

              <InputBox className="no-round width32 text-center">
                <p className="big font-bold" style={{ lineHeight: "36px" }}>{i + 1}</p>
              </InputBox>

              <div className="flex-line" style={{ alignItems: "flex-end" }}>
                <FormGroup
                  className="m-b-0"
                  title={i === 0 ? "Name" : null}
                  small_title={true}
                  no_border={true}>
                  <Input
                    className="no-round"
                    required={true}
                    style={{ width: "150px" }}
                    value={item.name}
                    onChange={(e) => this.change(i, "name", e.target.value)}/>
                </FormGroup>

                <FormGroup
                  className="m-b-0"
                  title={i === 0 ? "Rate (%)" : null}
                  small_title={true}
                  no_border={true}>
                  <InputNumber
                    type="number"
                    required={true}
                    className="no-round"
                    style={{ width: "150px" }}
                    value={item.rate}
                    change={(v) => this.change(i, "rate", v)}
                  />
                </FormGroup>

                <FormGroup
                  className="m-b-0"
                  title={i === 0 ? "Compound" : null}
                  small_title={true}
                  no_border={true}>
                  <InputBox className="no-round flex-center width75">
                    <Checkbox
                      id={`${i}-tax-compound`}
                      checked={item.compound}
                      onChange={(e) => this.change(i, "compound", e.target.checked)}/>
                  </InputBox>
                </FormGroup>

              </div>

              { (this.props.taxes.length - 1) === i &&
              <Tooltip text="Add" width={65} position="top">
                <Button type="button" className="no-round" paddinglr={5} color="white" onClick={this.add}>
                  <FaPlusCircle/>
                </Button>
              </Tooltip>
              }
              <Tooltip text="Delete" width={65} position="top">
                <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => this.remove(i)}>
                  <FaMinusCircle/>
                </Button>
              </Tooltip>
              <Tooltip text="Copy" width={65} position="top">
                <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => this.copy(i)}>
                  <FaCopy/>
                </Button>
              </Tooltip>

            </div>
          );
        })}

      </div>
    );
  }
}
